import { render, staticRenderFns } from "./osExterna.vue?vue&type=template&id=240d4494&"
import script from "./osExterna.vue?vue&type=script&lang=js&"
export * from "./osExterna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports